export const DEFAULT_GAP = 1;

export const DEFAULT_GRID_COLUMN_WIDTH = 360; // Used for Grid column and input / select widths

export const DEFAULT_MAX_ITEM_WIDTH = 720 + DEFAULT_GAP; // Max width an item should take up
